module.exports = __webpack_public_path__ + "pc/img/main_swiper03.956c829d.jpg";